import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    message: '',
    severity: '',
    status: null,
};
const messageSlice = createSlice({
    name: 'message',
    initialState,
    reducers: {
        setMessage: (state, action) => {
            return action.payload;
        },
        clearMessage: () => {
            return initialState;
        },
    },
});

export const { setMessage, clearMessage } = messageSlice.actions;
export default messageSlice.reducer;
